import React from "react";

import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";

import { Button, InputEmail, InputText, Icon } from "@rdcs/dap-front-library";

const AdminForm = ({
    editedAdmin: { firstName: firstNameAdmin = "", lastName: lastNameAdmin = "", email: emailAdmin = "" } = {},
    onSubmit,
    errors: { firstName: firstNameError = "", lastName: lastNameError = "", email: emailError = "" } = {},
    isLoading,
}) => {
    const location = useLocation();

    const [firstName, setFirstName] = React.useState(firstNameAdmin);
    const [lastName, setLastName] = React.useState(lastNameAdmin);
    const [email, setEmail] = React.useState(emailAdmin);
    const isEditMode = React.useMemo(() => emailAdmin !== "", []);

    const onSubmitCallback = (event) => {
        const form = {
            firstName,
            lastName,
        };

        event.preventDefault();
        if (!isEditMode) {
            form.email = email;
        }
        onSubmit(form);
    };

    return (
        <form className="form grid grid__padding-10" onSubmit={onSubmitCallback}>
            <div className="col-md-50">
                <InputText
                    label="Prénom"
                    placeholder="Saisissez votre prénom"
                    name="firstName"
                    error={firstNameError}
                    defaultValue={firstName}
                    required
                    onChange={setFirstName}
                />
            </div>
            <div className="col-md-50">
                <InputText
                    label="Nom"
                    placeholder="Saisissez votre nom"
                    name="lastName"
                    error={lastNameError}
                    defaultValue={lastName}
                    required
                    onChange={setLastName}
                />
            </div>
            <div className="col-100">
                <InputEmail
                    label="Email"
                    placeholder="Saisissez votre email"
                    error={emailError}
                    defaultValue={email}
                    required
                    onChange={setEmail}
                    disabled={isEditMode}
                />
            </div>
            <div className="form__group col-100 text-center">
                <Link
                    to={{
                        pathname: "/configuration",
                        state: { from: location },
                        tab: "admin",
                    }}
                >
                    <Button className="button__secondaryButton">
                        <Icon name="arrow-left" className="mr-1" /> Retour
                    </Button>
                </Link>
                <Button type="submit" className="button__primaryButton" isLoading={isLoading}>
                    Enregistrer
                </Button>
            </div>
        </form>
    );
};

AdminForm.propTypes = {
    editedAdmin: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
    }),
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
};

export default AdminForm;
